<template>
  <v-menu left bottom min-width="170">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        icon
        dark
      >
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item to="/profile">
        <v-list-item-avatar class="mx-0">
          <v-icon>mdi-account-circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-title>Profile</v-list-item-title>
      </v-list-item>
      <v-list-item @click="logout()">
        <v-list-item-avatar class="mx-0">
          <v-icon>mdi-logout-variant</v-icon>
        </v-list-item-avatar>
        <v-list-item-title>Logout</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  data(){
    return {}
  },
  methods : {
    logout(){
      localStorage.removeItem("flaacos_user");
      this.$router.push("/login");
    }
  }
}
</script>